module.exports = __webpack_public_path__ + "static/media/sell_food.a9f78056.svg";